import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const cards = [
  {
    number: "01",
    title: "Build Visibility",
    description:
      "Stand out in a crowded education market with positioning and messaging that learners instantly understand and remember.",
  },
  {
    number: "02",
    title: "Drive Enrolments",
    description:
      "Create learner journeys that turn awareness into enquiries, applications, and enrolments through smarter marketing systems.",
  },
  {
    number: "03",
    title: "Grow Relationships",
    description:
      "Keep learners engaged beyond enrolment with lifecycle marketing that builds trust, retention, and long-term advocacy.",
  },
];

export const BuiltFor = () => {
  return (
    <section id="built-for" className="bg-[#FAF7F2] text-[#1A2238] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
className="max-w-5xl mx-auto"        >
   <motion.div
  variants={fadeUp}
  className="max-w-7xl mx-auto"
>
            <p className="eyebrow text-[#FF6A3D] mb-5 text-center">
  WHO THIS IS BUILT FOR
</p>

<h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight leading-tight text-center max-w-4xl mx-auto">
  Digital Growth Partner for Your Edtech
</h2>
<p className="mt-6 max-w-3xl mx-auto text-lg text-[#1A2238]/65 leading-relaxed text-center">  Give your brand the digital acceleration it deserves
</p>

<div 
className="grid lg:grid-cols-3 md:grid-cols-2 gap-8 mt-20"
>
  {cards.map((card) => (
    <div
      key={card.number}
className="
group
bg-white
rounded-[28px]
p-10
border border-[#E9E9E9]
shadow-[0_10px_40px_rgba(26,34,56,0.06)]
hover:shadow-[0_30px_80px_rgba(26,34,56,0.14)]
hover:-translate-y-3
transition-all
duration-500
"    >
<div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#FF6A3D]/10 text-[#FF6A3D] font-display text-2xl font-extrabold">        {card.number}
      </div>

<h3 className="mt-8 font-display text-2xl font-bold tracking-tight leading-tight">
          {card.title}
      </h3>

      <p className="mt-4 text-[#1A2238]/65 leading-relaxed">
        {card.description}
      </p>
    </div>
  ))}
</div>

<div className="pt-16 flex justify-center">              <a
                href="https://cal.com/raj-rakshit-ssudkn"
                data-testid="builtfor-cta"
                className="group inline-flex items-center gap-3 bg-[#FF6A3D] text-[#FAF7F2] font-bold text-base py-2 pl-7 pr-2 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_36px_rgba(255,106,61,0.4)]"
              >
                Unlock Your Growth
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#1A2238] text-[#FAF7F2] transition-transform duration-300 group-hover:rotate-45">
                  <ArrowUpRight size={18} />
                </span>
              </a>
            </div>
          </motion.div>

          
        </motion.div>
      </div>
    </section>
  );
};
